import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Breakdown } from '../../../templates/Breakdown';

export const PeriodicGetBack: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicGetBack.${label}.${locale}.json`)}>
      <PeriodicGetBackComponent />
    </I18nProvider>
  );
};

export const PeriodicGetBackComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicGetBack'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Breakdown
      title={t('periodicGetBack.title')}
      content={t('periodicGetBack.content')}
      buttonHref={t('periodicGetBack.buttonLink.href')}
      buttonText={t('periodicGetBack.buttonLink.text')}
      footerLabel={t('periodicGetBack.priceDetailsFooterLabel')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicGetBack.imageSrc')}`,
        },
      }}
    />
  );
};
